const POOL_SIZE = 100;
const SPEED = 0.1;
const DEFAULT_DURATION = 700;
const DEFAULT_SPARK_COUNT = 10;
const INITIAL_RANDOM_SCATTER = 15;
const particles = [];

let $root = null;

export function initSparks(root) {
  $root = root;
  for (let i = 0; i < POOL_SIZE; i++) {
    const $particle = document.createElement("div");
    $particle.x = 0;
    $particle.y = 0;
    $particle.prevX = 0;
    $particle.prevY = 0;
    $particle.vx = 0;
    $particle.vy = 0;
    $particle.active = false;
    $particle.endTime = -1;
    particles.push($particle);
    $root.appendChild($particle);
  }
}

/**
 * Update spark physics - runs at fixed 60 Hz timestep.
 * @param {number} now - Current time in ms
 */
export function updateSparksPhysics(now) {
  for (let i = 0; i < POOL_SIZE; i++) {
    const $particle = particles[i];
    if (!$particle.active || now < $particle.startTime) continue;

    // Save previous position for interpolation
    $particle.prevX = $particle.x;
    $particle.prevY = $particle.y;

    // Update physics
    $particle.vx += -SPEED + Math.random() * SPEED * 2;
    $particle.vy += -SPEED + Math.random() * SPEED * 2;
    $particle.x += $particle.vx;
    $particle.y += $particle.vy;

    if (now > $particle.endTime) {
      $particle.active = false;
    }
  }
}

/**
 * Render sparks with interpolation for smooth visuals.
 * @param {number} now - Current time in ms
 * @param {number} alpha - Interpolation factor (0-1) between physics frames
 */
export function renderSparks(now, alpha) {
  for (let i = 0; i < POOL_SIZE; i++) {
    const $particle = particles[i];
    $particle.style.opacity =
      !$particle.active || now < $particle.startTime ? 0 : 1;
    if (!$particle.active || now < $particle.startTime) continue;

    // Interpolate between previous and current position
    const renderX = $particle.prevX + ($particle.x - $particle.prevX) * alpha;
    const renderY = $particle.prevY + ($particle.y - $particle.prevY) * alpha;
    $particle.style.transform = `translate(${renderX}px, ${renderY}px)`;
  }
}

function getParticle() {
  for (let i = 0; i < POOL_SIZE; i++) {
    const $particle = particles[i];
    if (!$particle.active) return $particle;
  }
  return null;
}

export function spark(
  now,
  x,
  y,
  vx,
  vy,
  count = DEFAULT_SPARK_COUNT,
  duration = DEFAULT_DURATION
) {
  const halfDuration = duration * 0.5;
  for (let i = 0; i < count; i++) {
    const $particle = getParticle();
    if ($particle) {
      $particle.x =
        x +
        -INITIAL_RANDOM_SCATTER +
        Math.random() * INITIAL_RANDOM_SCATTER * 2;
      $particle.y =
        y +
        -INITIAL_RANDOM_SCATTER +
        Math.random() * INITIAL_RANDOM_SCATTER * 2;
      // Initialize prev position to current to avoid interpolation glitch on spawn
      $particle.prevX = $particle.x;
      $particle.prevY = $particle.y;
      $particle.vx = vx * Math.random() * 5;
      $particle.vy = vy * Math.random() * 5;
      $particle.active = true;
      $particle.startTime = now + Math.random() * halfDuration;
      $particle.endTime =
        $particle.startTime + halfDuration + Math.random() * halfDuration;
    }
  }
}
